var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"literature"}},[_c('TopList',{attrs:{"navList":_vm.navList,"type":_vm.type},on:{"setType":_vm.setType}}),(_vm.type === 0)?_c('All'):_c('rests',{attrs:{"name":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }